import styled from '@emotion/styled';
import { Box } from '../Flexbox';
import { BoxProps } from '../Flexbox/Flexbox';

export type CenterProps = BoxProps;

export const Center = styled(Box)<CenterProps>({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
